import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import NotificationWrapper from '../components/NotificationWrapper';
import NotificationContainer from '../components/NotificationContainer';
import NotificationItem from '../components/NotificationItem';

import actions from './actions';

export const hiddenOnPaths = [
  '/accreditation',
  '/getting-to-know-you',
];

class RevalidateEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.retriggerValidateEmail();
    this.setState({
      loading: true,
    });
  }

  render() {
    const {
      isNonAuthenticated,
      revalidateEmailSent,
      location: {
        pathname,
      },
    } = this.props;
    const {
      loading,
    } = this.state;

    if (!isNonAuthenticated || revalidateEmailSent) {
      return null;
    }

    // Check if we're on a path that shouldn't display the message.
    if (hiddenOnPaths.includes(pathname)) {
      return null;
    }

    return (
      <NotificationWrapper>
        <NotificationContainer>
          <NotificationItem
            header="Please verify your email address in order to start investing."
            buttonText="Re-send Email"
            buttonProps={{
              onClick: () => !loading && this.handleClick(),
              loading,
            }}
          />
        </NotificationContainer>
      </NotificationWrapper>
    );
  }
}

RevalidateEmail.propTypes = {
  isNonAuthenticated: PropTypes.bool,
  revalidateEmailSent: PropTypes.bool,
  retriggerValidateEmail: PropTypes.func,
  location: PropTypes.object,
};

const mapStateToProps = (state) => ({
  isNonAuthenticated: state.app.user.isNonAuthenticated,
  revalidateEmailSent: state.revalidateEmail.revalidateEmailSent,
});

const mapDispatchToProps = (dispatch) => ({
  retriggerValidateEmail: () => {
    dispatch(actions.revalidateEmailRequested());
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RevalidateEmail));
